var map = {
	"./2015-11-11-public-trust.mdx": [
		18169,
		8169
	],
	"./2015-11-23-crime.mdx": [
		74617,
		4617
	],
	"./2015-12-11-lowest-grades.mdx": [
		9765,
		9765
	],
	"./2016-06-29-aff-action.mdx": [
		51798,
		1798
	],
	"./2016-09-20-paychecker.mdx": [
		84754,
		4754
	],
	"./2016-11-04-hacker.mdx": [
		11087,
		1087
	],
	"./2016-11-21-tumult.mdx": [
		47225,
		7225
	],
	"./2017-02-28-sexual-misconduct.mdx": [
		81113,
		1113
	],
	"./2017-03-28-building-berkeley.mdx": [
		95026,
		5026
	],
	"./2017-10-12-private-research.mdx": [
		37430,
		7430
	],
	"./2017-11-08-campus-meme.mdx": [
		15347,
		5347
	],
	"./2017-11-27-where-we-cry.mdx": [
		6783,
		6783
	],
	"./2017-11-28-bus-delay.mdx": [
		52117,
		2117
	],
	"./2018-04-13-campus-sex.mdx": [
		73424,
		3424
	],
	"./2018-04-24-great-equalizer.mdx": [
		31649,
		1649
	],
	"./2018-04-24-rack-location.mdx": [
		42750,
		2750
	],
	"./2018-09-22-peoples-park.mdx": [
		19780,
		9780
	],
	"./2019-03-18-berkeley-rent.mdx": [
		21856,
		1856
	],
	"./2020-05-17-graduation-2020.mdx": [
		57075,
		7075
	],
	"./2020-06-22-post-grad.mdx": [
		31580,
		1580
	],
	"./2020-07-24-college-plans.mdx": [
		20069,
		69
	],
	"./2020-09-13-diversity.mdx": [
		20773,
		773
	],
	"./2020-10-12-police-stops.mdx": [
		56194,
		6194
	],
	"./2020-10-26-voting.mdx": [
		97430,
		8928
	],
	"./2021-03-01-admissions-audit.mdx": [
		27011,
		7011
	],
	"./2021-06-04-150-timeline.mdx": [
		18251,
		8251
	],
	"./2021-06-18-uc-berkeley-pride-quantified.mdx": [
		57854,
		7854
	],
	"./2021-07-10-redlining.mdx": [
		2395,
		2395
	],
	"./2021-08-22-berkeley-guide-orientation.mdx": [
		63096,
		3096
	],
	"./2021-11-22-rent-shelter.mdx": [
		58161,
		8161
	],
	"./2021-11-23-hate-crimes.mdx": [
		33079,
		3079
	],
	"./2021-6-14-online-classes-suck.mdx": [
		27435,
		7435
	],
	"./2022-01-21-exodus.mdx": [
		84943,
		4943
	],
	"./2022-03-17-gym-pac-12.mdx": [
		78141,
		8141
	],
	"./2022-04-20-stem-enrollment.mdx": [
		82376,
		2376
	],
	"./2022-05-04-1921-timeline.mdx": [
		63638,
		3638
	],
	"./2022-09-15-study-abroad.mdx": [
		38587,
		8587
	],
	"./2022-09-22-artifacts.mdx": [
		55337,
		5337
	],
	"./2022-10-11-hsi.mdx": [
		95036,
		5036
	],
	"./2022-11-07-reddit.mdx": [
		69267,
		9267
	],
	"./2022-11-08-busd-gap.mdx": [
		93455,
		3455
	],
	"./2022-11-18-turnover.mdx": [
		43263,
		3263
	],
	"./2022-11-22-bargaining.mdx": [
		33835,
		3835
	],
	"./2022-12-09-kutcher.mdx": [
		37004,
		7004
	],
	"./2023-01-31-union-vote.mdx": [
		66111,
		6111
	],
	"./2023-03-01-rent-map.mdx": [
		38967,
		8967
	],
	"./2023-03-10-telegraph-pedestrianized.mdx": [
		18876,
		8876
	],
	"./2023-06-30-warnme.mdx": [
		13671,
		3671
	],
	"./2023-12-20-theft.mdx": [
		40657,
		657
	],
	"./2024-02-18-internal-audit.mdx": [
		48693,
		8693
	],
	"./2024-02-29-construction.mdx": [
		34224,
		4224
	],
	"./2024-04-19-coffee.mdx": [
		45851,
		5851
	],
	"./2024-05-20-baypass.mdx": [
		85158,
		5158
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98687;
module.exports = webpackAsyncContext;